<template>
  <SeoPillarLandingPage :content="$t('seoPillarUtm')" faq-src="/seo-faq/gerador-de-utm.json"/>
</template>
<script>
import SeoPillarLandingPage from "../fragments/SeoPillarLandingPage.vue";
export default {
  name: 'PillarGeradorDeUtm',
  components: { SeoPillarLandingPage },
}
</script>
